'use strict';

/**
 * Assignments: listado, filtros y acciones básicas (usando Assignment service)
 */
angular.module('thothApp.controllers')
  .controller('AssignmentsCtrl', ['$scope', '$state', '$q', 'Assignment', 'Employee', 'toaster', 'Pagination', function ($scope, $state, $q, Assignment, Employee, toaster, Pagination) {
    $scope.userIsAdmin = ($scope.userIsAdmin !== undefined) ? $scope.userIsAdmin : true;
    $scope.search = {
      employee_id: null,
      from: null,
      to: null,
      page: 1,
      per_page: 10,
      filters: {}
    };
    $scope.assignments = {
      list: [],
      pager: {}
    };
    $scope.selectedEmployee = null;
    $scope.searchEmployee = '';

    $scope.employeeSearch = function(searchQuery){
      if (!searchQuery) { return []; }
      var params = { params: { search: searchQuery, assignable: true, per_page: 10 } };
      var deferred = $q.defer();
      Employee.index(params).then(function(resp){
        var list = (resp.data && (resp.data.employees || resp.data)) || [];
        deferred.resolve(list);
      }).catch(function(err){
        if (Employee && Employee.error) { Employee.error(err); }
        deferred.reject(err);
      });
      return deferred.promise;
    };

    $scope.selectedEmployeeChange = function(emp){
      $scope.search.employee_id = emp && emp.id ? emp.id : null;
    };

    function formatLocalDate(date) {
      if (!date) { return null; }
      if (angular.isString(date)) { return date; }
      var d = new Date(date);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    }

    function paramsForApi() {
      var p = {
        page: $scope.search.page,
        per_page: $scope.search.per_page
      };
      if ($scope.search.employee_id) { p.employee_id = $scope.search.employee_id; }
      var fromStr = formatLocalDate($scope.search.from);
      var toStr   = formatLocalDate($scope.search.to);
      if (fromStr) { p.from = fromStr; }
      if (toStr)   { p.to   = toStr; }
      return p;
    }

    function load(page) {
      if (page) { $scope.search.page = page; }
      Assignment.index(paramsForApi())
        .then(function (resp) {
          var data = resp.data || {};
          $scope.assignments.list = data.assignments || [];
          $scope.assignments.pager = Pagination.GetPager(
            data.meta.pagination.total_objects,
            page,
            data.meta.pagination.per_page
          );
        })
        .catch(function (err) {
          Assignment.error(err);
        });
    }

    $scope.getPage = function (page) { load(page); };

    $scope.clearSearch = function () {
      $scope.search.employee_id = null;
      $scope.search.from = null;
      $scope.search.to = null;
      $scope.selectedEmployee = null;
      $scope.searchEmployee = '';
      $scope.getPage(1);
    };

    $scope.deleteAssignments = function (assignment) {
      if (!assignment || !assignment.id) { return; }
      if (!confirm('¿Estas seguro que deseas eliminar la asignación de ' + assignment.employee_name + ' con el producto ' + assignment.product_name + ' para el cliente ' + assignment.client_name + '?')) { return; }
      Assignment.destroy(assignment.id)
        .then(function () { $scope.getPage($scope.assignments.pager.current_page || 1); toaster.pop('success', 'Asignación eliminada correctamente.'); })
        .catch(function (err) { Assignment.error(err); toaster.pop('error', 'Error al eliminar la asignación.'); });
    };

    load(1);
  }]);